import axiosJs from '../api/index.js'
import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()

//todo : 엑셀 업로드 및 엑셀 다운로드 및 multipartfile 객체 통신일때 함수 추가
export default {
    /** 
    * @param {String} url api 호출 url
    * @param {Map} data 파라미터
    */
    callGet(url,data) { 
        if(data == null || data == undefined || data ==''){
            data = {}
        }
        // baseURL설정되어 있기 때문에 그 뒤의 URL만 작성합니다.
        return axiosJs.get(url,data)
    },
    /** 
    * @param {string} url - api 호출 url
    * @param {object} data - 파라미터
    * @param {boolean} setLoading - 해당 api call 에 대해 loading 적용 여부 (default - true)
    */
    async callPost(url, data, setLoading = true) {
        if(data == null || data == undefined || data ==''){
            data = {}
        }
        // try {
        //     if (setLoading) setIsLoading(true)
        //     const result = await axiosJs.post(url,data)
        //     return Promise.resolve(result)
        // } catch(e) {
        //     return Promise.reject(e)
        // } finally {
        //     setIsLoading(false)
        // }
        if (setLoading) setIsLoading(true)
        return axiosJs.post(url,data)
            .then(res => {
                return res
            })
            .catch(error => error)
            .finally(() => setIsLoading(false))
    },
    callPut(url,data) {
        if(data == null || data == undefined || data ==''){
            data = {}
        }
        return axiosJs.put(url,data)
    },
    callPatch(url,data) {
        if(data == null || data == undefined || data ==''){
            data = {}
        }
        return axiosJs.patch(url,data)
    },
    callDelete(url,data) {
        if(data == null || data == undefined || data ==''){
            data = {}
        }
        return axiosJs.delete(url,data)
    },

    callPutFile(url,data){
        if(data == null || data == undefined || data ==''){
            data = {}
        }
        return axiosJs.put(url,data,{
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
    }
    

    
}